import {
    INavigationProps,
    useStyles,
    INavigationItemState,
    INavigationItem,
    ConvertToNavigationItemState
} from "./shared/Navigation";
import { useHistory } from "react-router-dom";
import React from "react";
import { List, Menu, MenuItem, ListItem } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

export const FullNavigationMenu: React.FC<INavigationProps> = navigationProps => {
    const history = useHistory();
    const classes = useStyles(navigationProps?.classes);

    const [navigationItems, setNavigationItems] = React.useState(
        ConvertToNavigationItemState(navigationProps)
    );

    React.useEffect(() => {
        setNavigationItems(ConvertToNavigationItemState(navigationProps));
    }, [navigationProps]);

    const navigateToUrl = relativeUrl => {
        history.push(relativeUrl);
    };
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const openSubmenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const closeSubmenu = () => {
        //// by nulling the HTML element the menu is anchored the 'open' property of the menu becomes false, closing the menu.
        setAnchorEl(null);
    };

    const handleMenuItemClick = (navigationItemClicked: INavigationItem) => {
        //// does the navigation item have a click handler attached to it?
        if (navigationItemClicked.onClick) {
            //// call the attached click handler for the menu item.
            navigationItemClicked.onClick();
        } else {
            //// the menu item must provide navigation follow the link.
            navigateToUrl(navigationItemClicked.relativePath);
        }

        //// we are done with the menu now, so close it.
        closeSubmenu();
    };

    const getList = (
        list: Array<INavigationItemState>,
        listIndex: number = 0
    ) => {
        return (
            <List key={"list-" + listIndex} className={classes.list}>
                {list.map(function(
                    itemState: INavigationItemState,
                    listItemIndex
                ) {
                    const createSubmenu = itemState.item.nestedList ? (
                        <Menu
                            key={"list-" + listIndex + "-submenu"}
                            anchorEl={anchorEl}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left"
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "left"
                            }}
                            open={Boolean(anchorEl)}
                            onClose={closeSubmenu}
                        >
                            {itemState.item.nestedList.map(function(
                                item,
                                index
                            ) {
                                return (
                                    <MenuItem
                                        key={
                                            "list-" +
                                            listIndex +
                                            "-submenu-item-" +
                                            index
                                        }
                                        onClick={() =>
                                            handleMenuItemClick(item)
                                        }
                                    >
                                        {item.title}
                                    </MenuItem>
                                );
                            })}
                        </Menu>
                    ) : null;
                    return [
                        <ListItem
                            key={"listItem-" + listItemIndex}
                            className={classes.listItem}
                            onClick={event => {
                                if (itemState.item.nestedList) {
                                    openSubmenu(event);
                                } else {
                                    handleMenuItemClick(itemState.item);
                                }
                            }}
                        >
                            <a key={"link-" + listItemIndex}>
                                {itemState.item.title}
                            </a>

                            {itemState.item.nestedList ? (
                                <ExpandMore
                                    key={"icon-" + listItemIndex}
                                    className={classes.collapseIcons}
                                />
                            ) : null}
                        </ListItem>,
                        createSubmenu
                    ];
                })}
            </List>
        );
    };

    return navigationItems != null ? (
        <nav className={navigationProps.className}>
            {navigationItems.length === 0 && (
                <List className={classes.list}>
                    <ListItem
                        className={classes.listItem}
                        style={{ visibility: "hidden" }}
                    ></ListItem>
                </List>
            )}
            {getList(navigationItems)}
        </nav>
    ) : (
        <></>
    );
};
